import { configureStore } from '@reduxjs/toolkit';
import accountsReducer from './slices/accountsSlice';
import alertsReducer from './slices/alertsSlice';
import dashboardReducer from './slices/dashboardSlice';
import eventsReducer from './slices/eventsSlice';
import feedbackReducer from './slices/feedbackSlice';
import plansReducer from './slices/plansSlice';
import signupDataReducer from './slices/signupDataSlice';
import supportReducer from './slices/supportSlice';
import usersReducer from './slices/usersSlice';
import workspacesReducer from './slices/workspacesSlice';
import workspaceDetailReducer from './slices/workspaceDetailSlice';
import bundlePackagingReducer from './slices/bundlePackagingSlice';
import rbacReducer from './slices/rbacSlice';

const store = configureStore({
  reducer: {
    accounts: accountsReducer,
    alerts: alertsReducer,
    dashboard: dashboardReducer,
    events: eventsReducer,
    feedback: feedbackReducer,
    plans: plansReducer,
    signupData: signupDataReducer,
    support: supportReducer,
    users: usersReducer,
    workspaces: workspacesReducer,
    workspaceDetail: workspaceDetailReducer,
    bundlePackaging: bundlePackagingReducer,
    rbac: rbacReducer,
  },
});

export default store;